import { render, staticRenderFns } from "./Items.html?vue&type=template&id=cdbda8e6&scoped=true&external"
import script from "./Items.js?vue&type=script&lang=js&external"
export * from "./Items.js?vue&type=script&lang=js&external"
import style0 from "./Items.scss?vue&type=style&index=0&id=cdbda8e6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbda8e6",
  null
  
)

export default component.exports